<template>
  <div class="modal">
    <!-- =============== 预约提醒 弹出层 =============== -->
    <div class="tc-bg" v-if="type == 0">
      <div class="tc">
        <img src="@/assets/images/tc_tu1.jpg" class="warning" alt />
        <p v-html="msg"></p>
        <div class="btn">
          <a class="btn1" @click="closeModal">取消</a>
          <a class="btn2" @click="appointment">确定</a>
        </div>
      </div>
    </div>

    <!-- 重复预约弹窗 -->
    <div class="tc-bg" v-if="type > 0">
      <div class="tc" :class="{'succ':type == 1,'fail':type == 2}">
        <img v-if="type == 1" src="@/assets/images/tc_tu1.jpg" class="warning" alt />
        <img v-if="type == 2" src="@/assets/images/tc_tu2.jpg" class="warning" alt />
        <h3>{{title}}</h3>
        <p v-html="msg"></p>
        <div class="tc-btn">
          <button @click="closeModal" class="btn-ok">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: -1,
    },
    msg: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    callback: Function,
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.type = -1;
    },
    appointment() {
      if (this.callback) {
        this.callback();
      } else {
        console.log("appointment")
        this.$emit("appointment");
        //this.closeModal();
      }
    },
  },
  created() {},
};
</script>

<style scoped>
/* 弹窗样式 */
.tc-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
}
.tc-bg .tc {
  width: 5.8rem;
  height: 3.4rem;
  background-color: #fff;
  border-radius: 0.2rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.tc .tc-btn {
  text-align: center;
}
.tc-bg .btn-ok {
  width: 1.8rem;
  height: 0.54rem;
  text-align: center;
  border-radius: 0.27rem;
  font-size: 0.24rem;
  font-weight: 500;
  color: #ffffff;
  border: 0;
}
.tc h3 {
  text-align: center;
  font-size: 0.26rem;
  font-weight: bold;
}
.succ {
  border: 0.04rem solid #2d66e8;
}
.succ h3 {
  color: #2d66e8;
}
.succ .tc-btn .btn-ok {
  background-color: #0475df;
}
.fail {
  border: 0.04rem solid #f94668;
}
.fail h3 {
  color: #f94668;
}
.fail .tc-btn .btn-ok {
  background-color: #f94668;
}

.tc-bg .tc .close {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.2rem;
  height: 0.2rem;
  padding: 0.2rem;
  box-sizing: content-box;
}

.tc-bg .tc .warning {
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  margin-top: 0.33rem;
  margin-bottom: 0.17rem;
}

.tc-bg .tc p {
  font-size: 0.22rem;
  text-align: center;
  padding: 0.3rem 0.3rem;
  font-weight: 400;
  color: #666666;
}

.tc-bg .tc .btn {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem 1.26rem 0;
}
.tc-bg .tc .btn a {
  padding: 0.08rem 0.3rem;
  border: 0;
  font-size: 0.24rem;
  border-radius: 5rem;
  outline: none;
  color: #fff;
}
.tc-bg .tc .btn a.btn1 {
  background: #0b63c3;
}
.tc-bg .tc .btn a.btn2 {
  background: #ed4d4d;
}
</style>